import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=8d75d98e&scoped=true&"
import script from "./crud.vue?vue&type=script&lang=js&"
export * from "./crud.vue?vue&type=script&lang=js&"
import style0 from "./crud.vue?vue&type=style&index=0&id=8d75d98e&prod&lang=css&"
import style1 from "./crud.vue?vue&type=style&index=1&id=8d75d98e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d75d98e",
  null
  
)

export default component.exports